'use strict';

import DatePicker from './datePicker.directive';
import Drop from './drop.directive';
import RepeatComplete from './repeatComplete.directive';
import RepeatItemComplete from './repeatItemComplete.directive';
import BgImage from './bgImage.directive';
import Autofocus from './autofocus.directive';
import NgSubClass from './ngSubClass.directive';

export default angular
  .module('maestro.directives.common', [
    DatePicker,
    Drop,
    RepeatComplete,
    RepeatItemComplete,
    BgImage,
    Autofocus,
    NgSubClass
  ])
  .name;
